var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',_vm._g(_vm._b({staticStyle:{"z-index":"99999 !important"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},'v-tooltip',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.messages),function(text,index){return _c('v-row',{key:index},[_c('v-col',{attrs:{"cols":"12"}},[_c('span',[_vm._v(_vm._s(text))])])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }